var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopeIcon = function SvgEnvelopeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29 28V18.04q0-.151-.043-.29l-5.581 5.58 5.58 4.961A1 1 0 0 0 29 28M16.625 23.33l-5.581 4.961A1 1 0 0 1 11 28v-9.958q0-.151.043-.29zm3.043-1.367-7.888 7.011A1 1 0 0 0 12 29h16a1 1 0 0 0 .22-.025l-7.888-7.01a.5.5 0 0 0-.664 0m-8.815-5.561A2 2 0 0 0 10 18.04V28a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V18.04a2 2 0 0 0-.853-1.638l-8-5.6a2 2 0 0 0-2.294 0z",
    clipRule: "evenodd"
  })));
};
export default SvgEnvelopeIcon;